export enum CarTrackingStatus {
    RENTER = 'renter',
    VISITOR = 'visitor',
    ENFORCED = 'enforced',
    GRACE_PERIOD = 'grace period',
    VIOLATOR = 'violator',
}

export type CarTracking = {
    pk: number;
    spot_id: number;
    plate: string;
    state: string;
    creation_datetime: string;
    entrance_datetime: string | null;
    entrance_timestamp: number | null;
    entrance_image: string | null;
    entrance_license_plate_image: string | null;
    exit_datetime: string | null;
    exit_timestamp: number | null;
    exit_image: string | null;
    exit_license_plate_image: string | null;
    visit_count: number;
    rental_count: number;
    status: CarTrackingStatus | null;
    priority: number;
    is_cached: boolean;
    is_duplicate: boolean;
};

export type CameraImage = {
    camera_id: number;
    name: string;
    image_url: string;
    thumbnail_url?: string | null;
    event_datetime: number;
    coordinates?: ActiveCameraCoordinates | null;
};

export type CameraLatestImage = CameraImage & {
    orientation?: string;
};

export type CameraImageAtEventType = 'camera_event' | 'aerial_camera_event';

export type CameraImageAt = {
    image_url: string;
    thumbnail_url?: string | null;
    captured_at: string;
    event_type: CameraImageAtEventType;
    offset: number;
    has_newer: boolean;
    has_older: boolean;
};

export enum CameraOrientation {
    ENTRANCE = 'Entrance',
    EXIT = 'Exit',
}

type LPRImage = CameraImage & { orientation: CameraOrientation };

export type RecentCameraImages = {
    overhead_images: CameraImage[];
    lpr_images: LPRImage[];
};

export type AllCameraImage = {
    image_url: string;
    thumbnail_url?: string | null;
    camera_type: string;
    event_datetime: number;
};

export type HistoricalOccupancyDataPoint = {
    today_occupancy: number | null;
    past_avg_occupancy: number | null;
};

export type HistoricalOccupancy = {
    datapoints: Record<string, HistoricalOccupancyDataPoint>;
    today_peak: number;
    average_past_peak: number;
    current_occupancy: number;
};

export type EnforcementDailyScan = {
    rentals: number;
    enforcement_autostarts: number;
    unique_scanned_plates: number;
};

export type EnforcementStats = {
    total_scanned_plates_today: number;
    total_enforcement_autostart_today: number;
    enforcement_autostart_revenue_today: number;
    series_granularity?: 'day' | 'week';
    daily_scans: Record<string, EnforcementDailyScan>;
};

export type RentalStatsByTypeEntry = {
    count: number;
    percentage: number;
};

export type RentalStatsByType = {
    rental_counts: Record<string, RentalStatsByTypeEntry>;
};

export type ActiveCameraCoordinates = [number, number];

export type ActiveCamera = Record<string, unknown> & {
    id: number;
    notes: string;
    orientation: string;
    coordinates: ActiveCameraCoordinates | null;
    is_active: boolean;
    latest_image?: CameraLatestImage | null;
};
